// @flow

import { withTranslation } from '@i18n';
import React, { useRef, useState } from 'react';
import { useBreakpoint } from '@lib/hooks/useBreakpoint';

import {
  StyledCover,
  StyledMaxWidth,
  StyledSection,
  StyledHeading,
  StyledDetails,
  StyledItems,
  StyledItem,
  StyledNumber,
  StyledText,
  StyledVerticalLine,
  StyledSubText,
  StyledlineWrapper,
  StyledLineItem,
  StyledVideoSection,
  StyledContainer,
  StyledVideoContainer,
  StyledTextVideoContainer,
  StyledlineWrapperMobile,
  StyledVerticalLineMobile,
  StyledVideoMobile
} from './styles';

const HowItWorksVideo = ({ t }) => {
  const videoRef = React.useRef(null);
  const [count, setCount] = useState(0);

  const handleTimeUpdate = () => {
    const { currentTime } = videoRef.current || {};
    if (currentTime <= 8) {
      setCount(0);
    } else if (currentTime >= 9 && currentTime <= 20) setCount(1);
    else if (currentTime >= 21 && currentTime <= 35) setCount(2);
    else if (currentTime >= 36 && currentTime <= 45) setCount(3);
  };

  const isMobile: Boolean = useBreakpoint('mobile', 'desktop');

  const video1 = useRef(null);
  const video2 = useRef(null);
  const video3 = useRef(null);
  const video4 = useRef(null);


  React.useEffect(() => {
    if (videoRef.current) {
      videoRef.current.addEventListener('timeupdate', handleTimeUpdate);
    }
    return () => {
      if (videoRef.current) {
        videoRef.current.removeEventListener('timeupdate', handleTimeUpdate);
      }
    };
  }, []);

  const seekToTime = (time) => {
    (videoRef.current || {}).currentTime = time;
  };

  const block1ref = useRef(null);
  const block2ref = useRef(null);
  const block3ref = useRef(null);
  const block4ref = useRef(null);


  return (
    <>
      <StyledCover>
        <StyledMaxWidth>
          <StyledSection>
            <StyledHeading>{t('HowDoesItWorks')}</StyledHeading>
            {
              isMobile ? (
                <>
                  <StyledContainer>
                    <StyledItem ref={block1ref} id="Item1">
                      <StyledNumber className="active">{t('1')}</StyledNumber>
                      <StyledText>{t('Step1')}</StyledText>
                    </StyledItem>
                    <StyledVideoContainer>
                      <StyledlineWrapperMobile>
                        <StyledVerticalLineMobile />
                      </StyledlineWrapperMobile>
                      <StyledTextVideoContainer>
                        <StyledSubText>{t('Description1')}</StyledSubText>
                        <StyledVideoMobile>
                          <video
                            ref={video1}
                            loop
                            autoPlay
                            playsInline
                            id="video"
                            muted
                            className="videoclass"
                            poster="../../static/images/home/Signup-to-Begin.jpg"
                          >
                            <source src="https://yapita-production.s3.ap-south-1.amazonaws.com/images/Signup-to-Begin.mp4" type="video/mp4" />
                          </video>
                        </StyledVideoMobile>
                      </StyledTextVideoContainer>
                    </StyledVideoContainer>

                    <StyledItem ref={block2ref} id="Item2">
                      <StyledNumber className="active">{t('2')}</StyledNumber>
                      <StyledText>{t('Step2')}</StyledText>
                    </StyledItem>
                    <StyledVideoContainer>
                      <StyledlineWrapperMobile>
                        <StyledVerticalLineMobile />
                      </StyledlineWrapperMobile>
                      <StyledTextVideoContainer>
                        <StyledSubText>{t('Description2')}</StyledSubText>
                        <StyledVideoMobile>
                          <video
                            loop
                            autoPlay
                            id="video"
                            muted
                            playsInline
                            ref={video2}
                            className="videoclass"
                            poster="../../static/images/home/Finalize-Hospital.jpg"
                          >
                            <source src="https://yapita-production.s3.ap-south-1.amazonaws.com/images/Finalize-Hospital.mp4" type="video/mp4" />
                          </video>
                        </StyledVideoMobile>
                      </StyledTextVideoContainer>
                    </StyledVideoContainer>

                    <StyledItem ref={block3ref} id="Item3">
                      <StyledNumber className="active">{t('3')}</StyledNumber>
                      <StyledText>{t('Step3')}</StyledText>
                    </StyledItem>
                    <StyledVideoContainer>
                      <StyledlineWrapperMobile>
                        <StyledVerticalLineMobile />
                      </StyledlineWrapperMobile>
                      <StyledTextVideoContainer>
                        <StyledSubText>{t('Description3')}</StyledSubText>
                        <StyledVideoMobile>
                          <video
                            loop
                            autoPlay
                            id="video"
                            muted
                            playsInline
                            ref={video3}
                            className="videoclass"
                            poster="../../static/images/home/We-plan-your-Travel-and-Stay.jpg"
                          >
                            <source src="https://yapita-production.s3.ap-south-1.amazonaws.com/images/We-plan-your-Travel-Stay.mp4" type="video/mp4" />
                          </video>
                        </StyledVideoMobile>
                      </StyledTextVideoContainer>
                    </StyledVideoContainer>

                    <StyledItem ref={block4ref} id="Item4">
                      <StyledNumber className="active">{t('4')}</StyledNumber>
                      <StyledText>{t('Step4')}</StyledText>
                    </StyledItem>
                    <StyledVideoContainer>
                      <StyledlineWrapperMobile>
                        <StyledVerticalLineMobile />
                      </StyledlineWrapperMobile>
                      <StyledTextVideoContainer>
                        <StyledSubText>{t('Description4')}</StyledSubText>
                        <StyledVideoMobile>
                          <video
                            loop
                            autoPlay
                            id="video"
                            muted
                            playsInline
                            ref={video4}
                            className="videoclass"
                            poster="../../static/images/home/Get-Treated.jpg"
                          >
                            <source src="https://yapita-production.s3.ap-south-1.amazonaws.com/images/Get-Treated.mp4" type="video/mp4" />
                          </video>
                        </StyledVideoMobile>
                      </StyledTextVideoContainer>
                    </StyledVideoContainer>
                  </StyledContainer>
                </>
              )
                : (
                  <StyledDetails>
                    <StyledItems>
                      <StyledItem>
                        <StyledNumber className={count === 0 ? 'active' : ''} onClick={() => { seekToTime(0); setCount(0); }}>{t('1')}</StyledNumber>
                        <StyledText className={count === 0 ? 'active' : ''} onClick={() => { seekToTime(0); setCount(0); }}>{t('Step1')}</StyledText>
                      </StyledItem>
                      <StyledLineItem>
                        <StyledlineWrapper>
                          <StyledVerticalLine />
                        </StyledlineWrapper>
                        <StyledSubText>{t('Description1')}</StyledSubText>
                      </StyledLineItem>

                      <StyledItem>
                        <StyledNumber className={`${count === 1 ? 'active' : ''} ${count === 2 || count === 3 ? 'read' : ''}`}>{t('2')}</StyledNumber>
                        <StyledText className={count === 1 ? 'active' : ''} onClick={() => { seekToTime(9); setCount(1); }}>{t('Step2')}</StyledText>
                      </StyledItem>
                      <StyledLineItem>
                        <StyledlineWrapper>
                          <StyledVerticalLine />
                        </StyledlineWrapper>
                        <StyledSubText>{t('Description2')}</StyledSubText>
                      </StyledLineItem>

                      <StyledItem>
                        <StyledNumber className={`${count === 2 ? 'active' : ''} ${count === 3 ? 'read' : ''}`}>{t('3')}</StyledNumber>
                        <StyledText className={count === 2 ? 'active' : ''} onClick={() => { seekToTime(21); setCount(2); }}>{t('Step3')}</StyledText>
                      </StyledItem>
                      <StyledLineItem>
                        <StyledlineWrapper>
                          <StyledVerticalLine />
                        </StyledlineWrapper>
                        <StyledSubText>
                          {t('Description3')}
                          {' '}
                        </StyledSubText>
                      </StyledLineItem>

                      <StyledItem>
                        <StyledNumber className={count === 3 ? 'active' : ''}>{t('4')}</StyledNumber>
                        <StyledText className={count === 3 ? 'active' : ''} onClick={() => { seekToTime(36); setCount(3); }}>{t('Step4')}</StyledText>
                      </StyledItem>
                      <StyledLineItem>
                        <StyledlineWrapper>
                          <StyledVerticalLine />
                        </StyledlineWrapper>
                        <StyledSubText>
                          {t('Description4')}
                        </StyledSubText>
                      </StyledLineItem>
                    </StyledItems>

                    <StyledVideoSection>
                      <video
                        loop
                        autoPlay
                        id="video"
                        muted
                        playsInline
                        ref={videoRef}
                        poster="../../static/images/home/Signup-to-Begin.jpg"
                        style={{
                          width: '60%', marginLeft: 'auto', marginRight: 'auto', borderRadius: '20px'
                        }}
                      >
                        <source src="https://yapita-production.s3.ap-south-1.amazonaws.com/images/yapitah-health-how-it-works.mp4" type="video/mp4" />
                      </video>
                    </StyledVideoSection>

                  </StyledDetails>
                )
}

          </StyledSection>
        </StyledMaxWidth>
      </StyledCover>
    </>
  );
};

export default withTranslation('Home')(HowItWorksVideo);
